export default __webpack_public_path__ + "static/755-961c269769256bfa6d43d1733eaa8e35.gif";